import { BUDGET_YEAR_OFFSET } from './budget.js';
import { incomeRole, setChargeLines } from './budgetYear.js';
import { taxonomyIdOfLine } from './projection.js';
import { ZERO_AMOUNT, yearTotal } from './viewModel.js';
const budgetYear = (row) => yearTotal(row.years[BUDGET_YEAR_OFFSET] ?? ZERO_AMOUNT);
function projectedChargesOf(budget, scope) {
    return setChargeLines(budget, scope).reduce((sum, line) => sum + budgetYear(line), 0);
}
export function chargeScaleOf(budget, result, scope) {
    const projected = projectedChargesOf(budget, scope);
    return projected === 0 ? 1 : result.setCharges / projected;
}
export function chargesHaveALine(budget, result, chargesFallback, scope) {
    return (result.setCharges === 0 ||
        projectedChargesOf(budget, scope) !== 0 ||
        (chargesFallback !== undefined && !scope.edits.has(`taxonomy:${chargesFallback.taxonomyId}`)));
}
export function budgetSnapshot(budget, result, oneTimeLines, chargesFallback, scope) {
    const byTaxonomy = new Map();
    const add = (taxonomyId, direction, label, amount) => {
        if (taxonomyId === undefined)
            return;
        const existing = byTaxonomy.get(taxonomyId);
        byTaxonomy.set(taxonomyId, {
            taxonomyId,
            direction,
            label: existing?.label ?? label,
            amount: (existing?.amount ?? 0) + amount,
        });
    };
    const setLines = setChargeLines(budget, scope);
    const setIds = new Set(setLines.map((line) => line.id));
    const projectedCharges = projectedChargesOf(budget, scope);
    const chargeScale = chargeScaleOf(budget, result, scope);
    for (const group of budget.income) {
        if (incomeRole(group, scope.kind) === 'fund')
            continue;
        for (const line of group.lines) {
            const scale = setIds.has(line.id) ? chargeScale : 1;
            add(taxonomyIdOfLine(line.id), 'income', line.label, budgetYear(line) * scale);
        }
    }
    const fallback = projectedCharges === 0 &&
        chargesFallback !== undefined &&
        !scope.edits.has(`taxonomy:${chargesFallback.taxonomyId}`)
        ? chargesFallback
        : undefined;
    if (fallback !== undefined && result.setCharges !== 0) {
        add(fallback.taxonomyId, 'income', fallback.label, result.setCharges);
    }
    const oneTime = new Map(oneTimeLines.map((item) => [item.id, item]));
    for (const group of budget.expense) {
        for (const line of group.lines) {
            const taxonomyId = taxonomyIdOfLine(line.id) ?? oneTime.get(line.id)?.taxonomyId;
            add(taxonomyId, 'expense', line.label, budgetYear(line));
        }
    }
    const rounded = [...byTaxonomy.values()].map((line) => ({
        ...line,
        amount: Math.round(line.amount),
    }));
    const chargeIds = new Set(setLines.map((l) => taxonomyIdOfLine(l.id)).filter((id) => id !== undefined));
    if (fallback !== undefined)
        chargeIds.add(fallback.taxonomyId);
    const chargeLines = rounded.filter((line) => chargeIds.has(line.taxonomyId));
    const largest = chargeLines.reduce((best, line) => (best === undefined || line.amount > best.amount ? line : best), undefined);
    if (largest !== undefined) {
        const total = chargeLines.reduce((sum, line) => sum + line.amount, 0);
        largest.amount += Math.round(result.setCharges) - total;
    }
    return rounded.filter((line) => line.amount !== 0);
}
//# sourceMappingURL=snapshot.js.map